import { jsx } from "react/jsx-runtime";
import { cn } from "@tameeni/shared-logic";
import * as React from "react";
import { Button } from "../button/button.js";
import { Icon } from "@tameeni/icons";
import { tv } from "tailwind-variants";
const navigationButtonVariants = tv({
  base: "flex items-center justify-center rounded-lg font-normal cursor-pointer px-2 min-w-10 h-10 max-w-fit",
  variants: {
    disabled: {
      true: "pointer-events-none text-slate-300",
      false: "cursor-pointer"
    },
    isActive: {
      true: "bg-slate-300 text-slate-900 hover:text-slate-900",
      false: "hover:bg-slate-100 text-slate-500 hover:text-slate-600"
    }
  }
});
const Pagination = ({ className, ...props }) => /* @__PURE__ */ jsx(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: cn("mx-auto flex w-full justify-center", className),
    ...props
  }
);
Pagination.displayName = "Pagination";
const PaginationContent = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "ul",
  {
    ref,
    className: cn("flex flex-row items-center gap-1", className),
    ...props
  }
));
PaginationContent.displayName = "PaginationContent";
const PaginationItem = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("li", { ref, className: cn("", className), ...props }));
PaginationItem.displayName = "PaginationItem";
const PaginationLink = ({
  className,
  isActive,
  children,
  disabled = false,
  ...props
}) => /* @__PURE__ */ jsx(
  Button,
  {
    "aria-current": isActive ? "page" : void 0,
    className: navigationButtonVariants({ isActive, disabled, className }),
    disabled,
    variant: "text",
    ...props,
    children
  }
);
PaginationLink.displayName = "PaginationLink";
const PaginationPrevious = ({
  className,
  disabled,
  ...props
}) => /* @__PURE__ */ jsx(
  PaginationLink,
  {
    "aria-label": "Go to previous page",
    "aria-disabled": disabled,
    disabled,
    className: navigationButtonVariants({ disabled, className }),
    ...disabled ? { onClick: void 0, tabIndex: -1 } : props,
    children: /* @__PURE__ */ jsx(Icon, { name: "Chevron", className: "rotate-180 rtl:rotate-0" })
  }
);
PaginationPrevious.displayName = "PaginationPrevious";
const PaginationNext = ({
  className,
  disabled,
  ...props
}) => /* @__PURE__ */ jsx(
  PaginationLink,
  {
    "aria-label": "Go to next page",
    "aria-disabled": disabled,
    className: navigationButtonVariants({ disabled, className }),
    ...disabled ? { onClick: void 0, tabIndex: -1 } : props,
    disabled,
    children: /* @__PURE__ */ jsx(Icon, { name: "Chevron", className: "rtl:rotate-180 rotate-0" })
  }
);
PaginationNext.displayName = "PaginationNext";
const PaginationEllipsis = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  "span",
  {
    "aria-hidden": true,
    className: cn(
      "w-10 h-10 flex items-center justify-center text-slate-600",
      className
    ),
    ...props,
    children: "..."
  }
);
PaginationEllipsis.displayName = "PaginationEllipsis";
export {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious
};
